import { LoginHelper } from "./LoginHelper";

export function isSiteAdmin() {
	return (
		LoginHelper.isLoggedIn() &&
		LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN
	);
}

/** Show owner management UI and/or admin management entry on public detail pages. */
export function canShowDetailManagement(isOwner, extra = false) {
	return Boolean(isOwner || extra || isSiteAdmin());
}
